import { render, staticRenderFns } from "./PidDashPendingWork.vue?vue&type=template&id=7800dd2d&scoped=true&"
import script from "./PidDashPendingWork.vue?vue&type=script&lang=js&"
export * from "./PidDashPendingWork.vue?vue&type=script&lang=js&"
import style0 from "./PidDashPendingWork.vue?vue&type=style&index=0&id=7800dd2d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7800dd2d",
  null
  
)

export default component.exports